// @ts-nocheck
import { sortSelectStyles } from "@insite/content-library/Widgets/ProductList/ProductListSortSelect";
import { FormInputWrapper } from "@insite/mobius/FormField";
import { IconWrapper } from "@insite/mobius/Icon";
import breakpoint from "@toolkit/Framework/Common/Utilities/breakpoint";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { css } from "styled-components";

Object.assign(sortSelectStyles, {
    select: {
        labelProps: {
            css: css`
                ${x => x.theme.formField.defaultProps?.labelProps?.css};
                padding: 0 ${pxToRem(10)} 0 0;
                width: auto;
            `,
        },
        cssOverrides: {
            formField: css`
                justify-content: flex-start;
                align-items: center;
                margin-top: ${pxToRem(15)};

                ${breakpoint("sm")} {
                    justify-content: flex-end;
                    margin-top: 0;
                }

                ${FormInputWrapper} {
                    width: auto;

                    ${IconWrapper} {
                        height: 36px;
                    }

                    select {
                        height: 40px;
                    }
                }
            `,
        },
    },
});
